/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms

val POLE_WYMAGANE = "Pole nie może być puste"

data class ApiRequest(
  val paramMap: Map<String, String?> = emptyMap()
)

data class ApiResultUrl(
  val url: String
)

data class ApiResultDocument(
  val dokument: String,
  val validXsd: Boolean,
  val validMessage: String?
)

data class XmlAdres(
  val kodPocztowy: String?,
  val miejscowosc: String?,
  val ulica: String?,
  val budynek: String?,
  val lokal: String?,
  val kraj: String?,
  val terc: String?
)

enum class TypPodmiotu {
  OSOBA_FIZYCZNA,
  INNY_PODMIOT
}

data class XmlPodmiot(
  val typ: TypPodmiotu,
  val nazwa: String?,
  val nazwisko: String?,
  val imie: String?,
  val drugieImie: String?,
  val adres: XmlAdres?,
  val pesel: String?,
  val krs: String?,
  val nip: String?,
  val regon: String?,
  val email: String?
)
